import { render, staticRenderFns } from "./addFrequency.vue?vue&type=template&id=7eda42fc&"
import script from "./addFrequency.vue?vue&type=script&lang=js&"
export * from "./addFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports